import React, { useState } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import useFetch from "../../hooks/useFetch";

const Banner = () => {
  const [dotActive, setDocActive] = useState(0);
  const { data, loading, error } = useFetch(`/app/banners`);

  if (loading) return (
    <div className="w-full h-64 md:h-96 animate-pulse bg-gray-200 rounded-lg">
      <div className="w-full h-full flex items-center justify-center">
        <p className="text-gray-500">Loading...</p>
      </div>
    </div>
  );

  if (error) return (
    <div className="w-full p-4 bg-red-50 rounded-lg">
      <p className="text-red-500">Error: {error.message}</p>
    </div>
  );

  if (!data?.data?.length) return (
    <div className="w-full p-4 bg-gray-50 rounded-lg">
      <p className="text-gray-500">No banners available</p>
    </div>
  );

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    beforeChange: (prev, next) => {
      setDocActive(next);
    },
    appendDots: (dots) => (
      <div
        style={{
          position: "absolute",
          bottom: "20px", // Changed from top: 50%
          left: "50%", // Center horizontally
          transform: "translateX(-50%)", // Center adjust
          display: "flex", // Make children horizontal
          alignItems: "center", // Vertical center
          gap: "20px" // Space between elements
        }}
      >
        {/* Left Arrow */}


        {/* Dots */}
        <ul style={{
          margin: "0px",
          padding: "0px",
          display: "flex",
          gap: "8px",
          listStyle: "none"
        }}>
          {dots}
        </ul>

        {/* Right Arrow */}

      </div>
    ),
    customPaging: (i) => (
      <div
        style={
          i === dotActive
            ? {
              width: "30px",
              color: "transparent",
              borderBottom: "3px #262626 solid",
              padding: "8px 0",
              cursor: "pointer",
            }
            : {
              width: "30px",
              color: "transparent",
              borderBottom: "3px white solid",
              padding: "8px 0",
              cursor: "pointer",
            }
        }
      >
        0{i + 1}
      </div>
    ),
    responsive: [
      {
        breakpoint: 576,
        settings: {
          dots: true,
          appendDots: (dots) => (
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "2%",
                transform: "translateY(-50%)",
              }}
            >
              <ul style={{ margin: "0px" }}> {dots} </ul>
            </div>
          ),
          customPaging: (i) => (
            <div
              style={
                i === dotActive
                  ? {
                    width: "25px",
                    color: "#262626",
                    borderRight: "3px #262626 solid",
                    cursor: "pointer",
                    fontSize: "12px",
                  }
                  : {
                    width: "25px",
                    color: "transparent",
                    borderRight: "3px white solid",
                    cursor: "pointer",
                    fontSize: "12px",
                  }
              }
            >
              0{i + 1}
            </div>
          ),
        },
      },
    ],
  };

  return (
    <div className="w-full max-w-screen-2xl mx-auto  sm:pt-6 lg:pt-8">
      <div className="relative w-full">
        <Slider {...settings} className="banner-slider">
          {data.data.map((item, index) => (
            <Link 
              to={item.Link} 
              key={index}
              className="block relative w-full focus:outline-none"
            >
              <div className="aspect-[24/8] relative overflow-hidden rounded-lg">
                <img
                  src={`https://back.kayanmarketeg.com/img/${item.image}`}
                  alt={item.title || "Banner image"}
                  className="absolute inset-0 w-full h-full object-cover object-center transform hover:scale-105 transition-transform duration-700"
                  loading={index === 0 ? "eager" : "lazy"}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />
              </div>
            </Link>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default Banner;